import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { UnlinkParentChildCommand } from './unlink-parent-child.command';
import { UnlinkParentChildResult } from './unlink-parent-child.result';

/**
 * Unlink parent/child use case.
 * Removes a parent or child relationship between cases.
 */
@Injectable({ providedIn: 'root' })
export class UnlinkParentChildUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: UnlinkParentChildCommand): Observable<UnlinkParentChildResult> {
    this._state.setErrorParentChildCases(null);

    return this._repository.unlinkParentChild(command.caseId, command.linkedCaseId).pipe(
      tap(() => {
        // Caller is responsible for reloading state after success
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorParentChildCases(error.message || 'Failed to unlink parent/child case');
        return throwError(() => error);
      })
    );
  }
}
